<v-breadcrumbs :items="breadcrumbs" class="p-0 mb-2">
    <template v-slot:item="{ item }">
        <a v-if="item.external" :href="item.href" target="_blank" :disabled="item.disabled">
            {{item.text}}
        </a>
        <v-breadcrumbs-item v-else :to="item.to" :href="item.href" :disabled="item.disabled" :link="item.link"
            :exact="item.exact">
            {{item.text}}
        </v-breadcrumbs-item>
    </template>
</v-breadcrumbs>